import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef
} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { sandBoxData } from "../../../models/sandBoxData";
import { Router } from "@angular/router";
import { MockStoreService } from "src/app/services/mock-store.service";
import { CommunicationService } from "src/app/services/communication.service";
import { GeneralService } from "src/app/services/general.service";
// import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { timeout } from "rxjs/operators";
import { AuthResponse } from "src/app/models/auth";

interface State {
  id: string;
  value: string;
}
@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.css"]
})
export class RegisterComponent implements OnInit, AfterViewInit {
  @ViewChild("trigger") triggerBtn: ElementRef;
  @ViewChild("verificationButton") verificationBtn: ElementRef;
  registerForm: FormGroup;
  verificationForm: FormGroup;
  // emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  phoneRegex = /[0-9]{11}/;
  states: State[] = [];

  showOrHide: boolean = false;
  showOrHideText: string = "Click to see your password";
  verificationEmail: string;
  businessTypes: any[] = [
    { id: 1, value: "fashion" },
    { id: 2, value: "cosmetics" },
    { id: 3, value: "jewelries" },
    { id: 4, value: "electronics" },
    { id: 5, value: "computers" },
    { id: 6, value: "furnitures" },
    { id: 7, value: "gaming" },
    { id: 8, value: "fragrances" },
    { id: 9, value: "groceries" },
    { id: 10, value: "beers, wines and spirits" }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public mockStore: MockStoreService,
    private commservice: CommunicationService,
    private generalservice: GeneralService
  ) {
    const { states } = sandBoxData().data;
    this.states = [...states];
  }

  ngOnInit() {
    this.verificationForm = this.fb.group({
      token: ["", Validators.required]
    });
    this.registerForm = this.fb.group({
      email: [
        "",
        [Validators.required, Validators.pattern(this.mockStore.emailRegex)]
      ],
      name: ["", Validators.required],
      // phone: ["", [Validators.required, Validators.pattern(this.phoneRegex)]],
      password: ["", Validators.required],
      business_type: ["", Validators.required]
    });
  }

  ngAfterViewInit() {
    // this.trigger = thias HTMLButtonElement;
  }

  // getters for registerForm
  get email() {
    return this.registerForm.get("email");
  }
  get name() {
    return this.registerForm.get("name");
  }
  // get phone() {
  //   return this.registerForm.get("phone");
  // }
  // get state() {
  //   return this.registerForm.get("state_id");
  // }
  // get country() {
  //   return this.registerForm.get("country_id");
  // }

  // get address() {
  //   return this.registerForm.get("address");
  // }
  get password() {
    return this.registerForm.get("password");
  }
  get business_type() {
    return this.registerForm.get("business_type");
  }

  // conformToEmailPattern(): boolean {
  //   return this.email.hasError("pattern") && this.email.touched
  // }
  // Validation Errors controls
  emailIsRequired(): boolean {
    return this.email.hasError("required") && this.email.touched;
  }
  conformToEmailPattern(): boolean {
    return this.email.hasError("pattern") && this.email.dirty;
  }
  nameIsRequired() {
    return this.name.hasError("required") && this.name.touched;
  }

  // stateIsRequired(): boolean {
  //   return this.state.hasError("required") && this.state.touched;
  // }

  // addressIsRequired(): boolean {
  //   return this.address.hasError("required") && this.address.touched;
  // }

  // phoneIsRequired(): boolean {
  //   return this.phone.hasError("required") && this.phone.touched;
  // }
  // conformToPhonePattern(): boolean {
  //   return this.phone.hasError("pattern") && this.phone.dirty;
  // }

  passwordIsRequired(): boolean {
    return this.password.hasError("required") && this.password.dirty;
  }
  // this function shows or hides the password
  togglePassword(event: Event): void {
    const span = (event.srcElement as HTMLElement).closest(
      "span"
    ) as HTMLSpanElement;
    if (!this.showOrHide) {
      (span.previousElementSibling as HTMLInputElement).type = "text";
      this.showOrHide = true;
      this.showOrHideText = "Click to hide your password";
    } else {
      (span.previousElementSibling as HTMLInputElement).type = "password";
      this.showOrHide = false;
      this.showOrHideText = "Click to see your passwprd";
    }
  }

  //  this function will submit the form
  submitForm(form: FormGroup) {
    let btn = document.getElementById("registerButton") as HTMLButtonElement;
    // (this.triggerBtn.nativeElement as HTMLButtonElement)
    btn.disabled = true;
    btn.innerHTML = this.mockStore.spinner;
    const { email } = form.value;
    this.mockStore.verificationEmail = email;
    this.commservice.sendRegisterDetailsToServer(form.value).subscribe(
      (val: AuthResponse) => {
        const { token, completion_details } = val;
        this.generalservice.saveCompletionStatus(completion_details);
        this.generalservice.handleSuccessAndNotifyUser(val);
        this.generalservice.setToken(token);
        btn.disabled = false;
        btn.innerHTML = "CONTINUE";
        this.triggerBtn.nativeElement.click();
      },
      err => {
        this.generalservice.handleError(err);
        btn.disabled = false;
        btn.innerHTML = "CONTINUE";
      }
    );

    // console.log(email);
  }

  moveForward() {
    const btn = document.querySelector("#trigger") as HTMLButtonElement;
    btn.click();
    this.router.navigate(["/dashboard"]);
  }

  sendVerification(form: FormGroup) {
    this.verificationBtn.nativeElement.innerHTML = this.mockStore.spinner;
    this.commservice
      .verifyMerchantEmail(form.value)
      .pipe(timeout(50000))
      .subscribe(
        val => {
          this.verificationBtn.nativeElement.innerHTML = "Verify email";
          this.generalservice.handleSuccessAndNotifyUser(val);
          const { token, message } = val;
          this.triggerBtn.nativeElement.click();
          this.generalservice.setToken(token);
          this.router.navigate(["/items"]);
        },
        err => this.generalservice.handleError(err)
      );
  }
}
